import { Component, Vue } from "vue-property-decorator";
import signalContent from "@/components/signalContent/signalContent.vue";
import VueStore from "@/store/VueStore";
import { AddSignallamp } from "./scripts/add_signallamp";
import { DeleteSignallamp } from "./scripts/delete_signallamp";
import Chart from "chart.js";
import CognitoController from "@/common/scripts/cognito_controller";
const draggable = require("vuedraggable");
import { translate, i18n } from "@/main";

@Component({
  name: "indexSignal",
  created() {
    this.$parent.$children[0].$data.headerElement = true;
  },
  components: {
    signalContent,
    draggable,
  },
  methods: {
    /**
     * ランプパネル削除処理。
     * @param {number} signallampID ランプID
     * @param {string} location ランプ設置場所
     * @returns {Promise<void>} Promise
     */
    async deleteSignallamp(signallampID: number, location: string) {
      let deleteConfirmMessage: string = "";
      // 変数入りのメッセージが文法上おかしくないようif分岐
      if (i18n.locale === "ja") {
        deleteConfirmMessage =
        `"${location}"` + translate("message.areYouSureYouWantToDeleteStackLight")
        + translate("message.allSettingsAndAlarmHistoryWillAlsoBeDeleted");
      } else {
        deleteConfirmMessage = translate("message.areYouSureYouWantToDeleteStackLight")
        + `"${location}"` + this.$t("message.questionMark")
        + translate("message.allSettingsAndAlarmHistoryWillAlsoBeDeleted");
      }
      const deleteCheck = confirm(deleteConfirmMessage);
      if (deleteCheck) {
        try {
          await DeleteSignallamp(signallampID, this.$data);
        } catch (e) {
          alert(this.$t("message.failedToDeleteStackLightPanel"));
        }
      }
    },
  },
})
export default class IndexSignal extends Vue {
  /**
   * ローカルデータのsignallampIDsを取得する
   * 初期状態などデータが存在していない場合は空配列を返す
   * @returns {number[]} ローカルデータのsignallampIDs
   */
  private static getsignallampIDs(): number[] {
    let result = JSON.parse(localStorage.getItem("graphSettings")).signallampIDs;
    if (typeof result === "undefined") {
      result = [1];
    }
    return result;
  }
  public signallampIDs: number[] = [];
  public token: string = VueStore.state.token;
  public chart: Chart;
  public historyArea: boolean = false;
  public alertHistoryArea: boolean = false;
  public canvasArea: boolean = true;
  public historyDatasets: any = [];
  public historyTitle: string = "";
  public alertHistoryTitle: string = "";
  public alertHistoryData: any = [];
  public overlayArea: boolean = false;
  public FromTime: string = "2018-01-01 00:00:00";
  public ToTime: string = "2019-01-01 00:00:00";
  public draggable: boolean = true;
  public options: any = {
    animation: 200,
    draggable: ".el-col",
    handle: ".drag-area",
    disabled: this.draggable,
  };
  public created() {
    this.$parent.$children[0].$data.headerElement = true;
    this.signallampIDs = IndexSignal.getsignallampIDs();
  }
  /**
   * 過去状況を非表示にする
   */
  public hiddenCanvasArea() {
    if (typeof this.$data.chart !== "undefined") {
      this.$data.chart.destroy();
    }
    this.historyArea = false;
    this.alertHistoryArea = false;
    this.overlayArea = false;
  }

  public hiddenAlertHistoryArea() {
    this.alertHistoryArea = false;
    this.overlayArea = false;
  }

  public changeGraphHistory() {
    this.canvasArea = true;
  }

  public changeDataHistory() {
    this.canvasArea = false;
  }

  /**
   * 並び替えモードに切り替え
   */
  public changeSortMode() {
    this.options.disabled = !this.draggable;
    const signalContentComponents = this.$children[0].$children;
    signalContentComponents.forEach((component: any) => {
      component.$children[0].$data.signalArea = !component.$children[0].$data
        .signalArea;
    });
  }

  /**
   * 切り替えモードの終了
   */
  public finishSortMode() {
    this.options.disabled = false;
    const signalContentComponents = this.$children[0].$children;
    signalContentComponents.forEach((component: any) => {
      component.$children[0].$data.signalArea = true;
    });
  }

  /**
   * 並び替えた状態を保存
   */
  public async updateSignalIDs() {
    const cognitoController = new CognitoController();
    const newsignallampIDs: number[] = this.signallampIDs;
    cognitoController.setSignallampIDs(newsignallampIDs);
    await cognitoController.update();
  }

  /**
   * ランプパネル追加処理。
   * @returns {Promise<void>} Promise
   */
  public async addSignallamp() {
    try {
      await AddSignallamp(this);
    } catch (e) {
      alert(this.$t("message.failedToAddStackLightPanel"));
      console.error(e);
    }
  }
}
